<template>
	<div class="m-sign" v-if="showSign" @click="handleClose">
		<div class="m-sign-content" @click.stop>
			<div class="m-sign-re-write" @click="rewrite">{{ $t('重写') }}</div>
			<div class="m-sign-remove" @click="remove">{{ $t('删除') }}</div>
			<div class="m-sign-close" @click="handleClose">
				{{ $t('取消') }}
			</div>
		</div>
	</div>
</template>

<script>
import { mapMutations } from 'vuex';
const LANG_EN = {
	重写: 'Rewrite',
	删除: 'Delete',
	取消: 'Cancel'
};

export default {
	props: {
		showSign: {
			type: Boolean,
			default: false
		},
		closeFun: {
			type: Function,
			default: () => ({})
		},
		lang: {
			type: String,
			default: 'CN'
		}
	},
	data() {
		return {
			langIsEn: false
		};
	},
	watch: {
		showSign(val) {
			if (val) {
				// 判断当前语言环境
				this.langIsEn = this.lang ? (this.lang == 'EN' ? true : false) : false;

				document.body.classList.add('van-overflow-hidden');
			} else {
				document.body.classList.remove('van-overflow-hidden');
			}
		}
	},
	computed: {
		changeLang() {
			return key => {
				return this.langIsEn ? (LANG_EN[key] ? LANG_EN[key] : key) : key;
			};
		}
	},
	methods: {
		...mapMutations(['setSignBase64']),
		handleClose: function () {
			if (typeof this.closeFun === 'function') {
				this.closeFun();
			}
		},
		rewrite() {
			this.$emit('rewrite');
			this.$track.send({
				content: '承诺书重写签字',
				event: 'CLICK',
				module: '沟通管理'
			});
			this.handleClose();
		},
		remove() {
			this.setSignBase64('');
			this.handleClose();
		}
	}
};
</script>

<style></style>
